
//引入需要添加的组件
import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui'
import BaiduMap from 'vue-baidu-map'
import vueAwesomeSwiper from "vue-awesome-swiper";
import imgUrl from '../src/utils/imgUrl'
import "swiper/dist/css/swiper.css";
import '../src/css/common.css'
import '../src/css/public.css'
import '../src/fonts/fonts.css'
import 'element-ui/lib/theme-chalk/index.css'


Vue.use(ElementUI)
Vue.use(vueAwesomeSwiper)
Vue.use(BaiduMap,{
  ak:'htbjr8wwTer0BczjSCzfWnjK7nGSRXTy'
})
Vue.prototype.$imgUrl = imgUrl
import router from './router'
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')